import styled from "styled-components";

export default function FooterBordura() {
  return <img src="/images/footer/bordura.jpg" alt="footer" />;
}
